"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = debounce;
function debounce(func, wait = 100, immediate = false) {
    let timeoutId = null;
    return function debounced(...args) {
        const context = this;
        const callNow = immediate && !timeoutId;
        const later = () => {
            timeoutId = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(later, wait);
        if (callNow) {
            return func.apply(context, args);
        }
        return undefined;
    };
}
